<template>
    <div>
        <el-table :data="replace_staff_List" style="width: 100%">
            <el-table-column align="center" label="序号" width="50">
                <template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
            </el-table-column>
            <el-table-column prop="staff_name" label="姓名" align="center"></el-table-column>
            <el-table-column prop="staff_card" label="身份证号" width="300px" align="center"></el-table-column>
            <el-table-column prop="staff_telephone" label="手机号" align="center"></el-table-column>
        </el-table>
    </div>
</template>

<script>
    export default {
        props: ["replace_staff_List"],
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// Dgsq_dgr.vue?38f42d3b